import React, { useState, useEffect } from 'react';
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Typography,
  IconButton,
  Box,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { Refresh } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import CustomDatePickerMui from './CustomDatePickerMui';

const styles = (theme) => ({
  // Layout styles for the main filter container
  mainContainer: {
    display: "flex",
    width: "100%",
    alignItems: "end",
    flexWrap: "nowrap",
    marginTop: "1rem",
  },
  // Layout for the left side search section
  searchBySection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "flex-start",
  },
  // Typography styles for filter labels
  filterLabel: {
    fontWeight: 550,
    whiteSpace: "nowrap",
    marginBottom: "1rem",
  },
  // Container for search input and button
  searchInputContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  // Styling for the criteria dropdown
  selectField: {
    border: "1px solid black",
    borderRight: "none",
    borderRadius: "0.1rem",
    backgroundColor: "#F0F0F0",
    minWidth: "150px",
  },
  // Styling for the search text input
  searchInput: {
    flex: 1,
    minWidth: 0,
    border: "1px solid black",
    borderTopRightRadius: "8px", 
    borderBottomRightRadius: "8px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
  // Styling for date picker inputs
  datePicker: {
    border: "1px solid black",
    borderRadius: "4px",
    minWidth: "120px",
  },
  // Orange search button styling
  searchButton: {
    backgroundColor: "#EB5E28",
    color: "white",
    borderTopRightRadius: "7px",
    borderBottomRightRadius: "7px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    padding: "8px",
    translate: "0.84rem",
    marginLeft: "0px",
    marginRight: "0px",
  },
});

const DigitizationFilters = ({ classes, onFilterChange, filters, rowsPerPage, onRowsPerPageChange, lastSyncTime, onRefresh, onSearch, onClearFilters }) => {
  // Local state to manage filter values before applying them
  const [localFilters, setLocalFilters] = useState(filters);

  // Sync localFilters with props when filters change externally (like clear filters)
  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  // Handle filter changes and sync with parent component
  const handleFilterChange = (field, value) => {
    let newFilters = { ...localFilters, [field]: value };
    
    // Clear searchKeyword when criteria changes
    if (field === 'criteria') {
      newFilters = { ...newFilters, searchKeyword: '' };
    }
    
    setLocalFilters(newFilters);
    onFilterChange(newFilters);
  };

  // Clears the search keyword input
  const handleClearSearch = () => {
    handleFilterChange('searchKeyword', '');
  };

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          width: "100%",
          alignItems: "end",
          flexWrap: "nowrap",
          marginTop: "1rem",
          justifyContent: "space-between",
        }}
      >
        <Grid
          item
          xs={12}
          sm={9}
          md={9}
          style={{
            display: "flex",
            // flexDirection: "column",
            // alignItems: "start",
            justifyContent: "flex-start",
            gap: "1rem",
          }}
        >
          {/* <Grid>
            
          </Grid> */}
          <Grid
            item
            style={{
              // display: "flex",
              // alignItems: "center",
              maxWidth: "390px",
            }}
            xs={6}
            sm={6}
            md={6}
          >
            <Typography
              style={{
                fontWeight: 550,
                whiteSpace: "nowrap",
                marginBottom: "1rem",
              }}
              className="dashboard-filter-labels"
            >
              View By:
            </Typography>
            <Box
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
              className="select-search-by-field"
            >
              <TextField
                size="small"
                select
                value={localFilters.criteria}
                onChange={(e) => handleFilterChange('criteria', e.target.value)}
                variant="outlined"
                style={{
                  border: "1px solid black",
                  borderRight: "none",
                  borderRadius: "0.1rem",
                  backgroundColor: "#F0F0F0",
                }}
                className="select-search"
              >
                <MenuItem value="all">Select Criteria</MenuItem>
                <MenuItem value="po_number">PO Number</MenuItem>
                <MenuItem value="batch_number">Batch Number</MenuItem>
                <MenuItem value="processing_status">Processing Status</MenuItem>
              </TextField>

              {localFilters.criteria === 'processing_status' ? (
                <div style={{ display: 'flex', flex: 1 }}>
                  <TextField
                    size="small"
                    select
                    value={localFilters.searchKeyword}
                    onChange={(e) => handleFilterChange('searchKeyword', e.target.value)}
                    variant="outlined"
                    placeholder="Select Status..."
                    disabled={localFilters.criteria === 'all'}
                    displayEmpty
                    style={{
                      flex: 1,
                      minWidth: 0,
                      border: "1px solid black",
                      borderRight: "none",
                      borderTopRightRadius: "0px", 
                      borderBottomRightRadius: "0px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                    }}
                    SelectProps={{
                      displayEmpty: true,
                      renderValue: (selected) => {
                        if (!selected) {
                          return <span style={{ color: '#999' }}>Select Status</span>;
                        }
                        return selected === 'processed' ? 'Processed' :
                               selected === 'processing' ? 'Processing' :
                               selected === 'queued' ? 'Queued' :
                               selected === 'failed' ? 'Failed' :
                               selected === 'unprocessed' ? 'Unprocessed' : selected;
                      }
                    }}
                  >
                    <MenuItem value="">Select Status</MenuItem>
                    <MenuItem value="processed">Processed</MenuItem>
                    <MenuItem value="processing">Processing</MenuItem>
                    <MenuItem value="queued">Queued</MenuItem>
                    <MenuItem value="failed">Failed</MenuItem>
                    <MenuItem value="unprocessed">Unprocessed</MenuItem>
                  </TextField>
                  <IconButton
                    size="small"
                    onClick={onSearch}
                    disabled={localFilters.criteria === 'all' || !localFilters.searchKeyword}
                    style={{
                      backgroundColor: (localFilters.criteria === 'all' || !localFilters.searchKeyword) ? "#ccc" : "#EB5E28",
                      color: "white",
                      borderTopRightRadius: "7px",
                      borderBottomRightRadius: "7px",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                      padding: "8px",
                      border: "1px solid black",
                      borderLeft: "none",
                      cursor: (localFilters.criteria === 'all' || !localFilters.searchKeyword) ? 'not-allowed' : 'pointer',
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </div>
              ) : (
                <TextField
                  size="small"
                  value={localFilters.searchKeyword}
                  onChange={(e) => handleFilterChange('searchKeyword', e.target.value)}
                  variant="outlined"
                  disabled={localFilters.criteria === 'all'}
                  placeholder={localFilters.criteria === 'all' ? 'Select criteria first...' : 
                    localFilters.criteria === 'po_number' ? 'Enter PO number...' :
                    localFilters.criteria === 'batch_number' ? 'Enter batch number...' :
                    'Search keyword...'}
                  style={{
                    flex: 1,
                    minWidth: 0,
                    border: "1px solid black",
                    borderTopRightRadius: "8px", 
                    borderBottomRightRadius: "8px",
                    borderTopLeftRadius: "0px",
                    borderBottomLeftRadius: "0px",
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {localFilters.searchKeyword && localFilters.criteria !== 'all' && (
                          <IconButton
                            size="small"
                            onClick={handleClearSearch}
                            style={{
                              padding: "4px",
                              marginRight: "4px",
                              color: "#666"
                            }}
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        )}
                        <IconButton
                          size="small"
                          onClick={onSearch}
                          disabled={localFilters.criteria === 'all'}
                          style={{
                            backgroundColor: localFilters.criteria === 'all' ? "#ccc" : "#EB5E28",
                            color: "white",
                            borderTopRightRadius: "7px",
                            borderBottomRightRadius: "7px",
                            borderTopLeftRadius: "0px",
                            borderBottomLeftRadius: "0px",
                            padding: "8px",
                            translate: "0.84rem",
                            marginLeft: "0px",
                            marginRight: "0px",
                            cursor: localFilters.criteria === 'all' ? 'not-allowed' : 'pointer',
                          }}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            </Box>
          </Grid>
          <Grid
            item
            style={{ display: "flex", gap: "8px", marginTop: "31px", width: "100%", alignItems: "center" }}
            xs={6}
            sm={6}
            md={6}
          >
            <CustomDatePickerMui
              name="dateFrom"
              value={localFilters.dateFrom || null}
              onChange={(date) => handleFilterChange('dateFrom', date)}
              placeholder="From"
              size="small"
              maxDate={localFilters.dateTo || new Date()}
              style={{
                border: "1px solid black",
                borderRadius: "4px",
                minWidth: "120px",
                maxWidth: "175px",
              }}
            />

            <CustomDatePickerMui
              name="dateTo"
              value={localFilters.dateTo || null}
              onChange={(date) => handleFilterChange('dateTo', date)}
              placeholder="To"
              size="small"
              maxDate={new Date()}
              style={{
                border: "1px solid black",
                borderRadius: "4px",
                minWidth: "120px",
                maxWidth: "175px",
              }}
            />

            {/* {(localFilters.dateFrom || localFilters.dateTo || localFilters.searchKeyword || localFilters.criteria !== 'all') && ( */}
              <Typography
                variant="caption"
                style={{
                  fontSize: 14,
                  color: "#EB5E28",
                  textDecoration: "underline",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  marginLeft: "8px",
                }}
                onClick={onClearFilters}
                title="Clear All Filters"
              >
                Clear Filters
              </Typography>
            {/* )} */}
          </Grid>
        </Grid>

        <Grid item style={{  marginLeft: "2rem" }}>
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
            }}
          >
            <Grid
              item
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Grid>
                <Typography
                  variant="body2"
                  style={{
                    color: "gray",
                    marginRight: "8px",
                    whiteSpace: "nowrap",
                  }}
                  className="last-synced-text"
                >
                  {`Last synced @ ${moment(lastSyncTime).format(
                                                        "DD-MMM-YYYY, HH:mm:ss"
                                                      )}`}
                </Typography>
              </Grid>
              <Grid>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    textDecoration: "underline",
                    fontStyle: "italic",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  className="refresh-button"
                  onClick={onRefresh}
                >
                  Refresh
                  <Refresh color="primary" fontSize="small" className="refresh-button"/>
                </Typography>
              </Grid>
            </Grid>

            <Grid
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: "10px",
                width: "100%",
              }}
              className="per-page-box" 
            >
              <Typography
                style={{
                  fontWeight: "bold",
                  marginRight: "4px",
                  whiteSpace: "nowrap",
                }}
              >
                PER PAGE
              </Typography>
              <FormControl variant="outlined" size="small">
                <Select
                  value={rowsPerPage}
                  onChange={onRowsPerPageChange}
                >
                  {/* <MenuItem value={5}>5</MenuItem> */}
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withStyles(styles)(DigitizationFilters);